import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2wk09p15nonvi">
    <p className="font-display text-xl font-semibold italic leading-relaxed text-brand-sageMid md:text-3xl" data-id="element-1" data-mp="2wiffjcn976y6">
      🌸 Tu próxima tandada empieza con criterio, no con improvisación.
    </p>
  </div>;
export function App({
  showSocialProofToast = true
}: {
  showSocialProofToast?: boolean;
}) {
  return <div className="min-h-screen w-full bg-brand-cream font-display text-brand-text selection:bg-brand-sageMist selection:text-brand-sageDeep" data-id="element-2" data-mp="3ijfunyhrpue3">
      <UrgencyBanner data-id="element-3" data-mp="3rcj6k2crlz6m" />
      <main data-id="element-4" data-mp="3rbzngibdp4r0">
        <Hero data-id="element-5" data-mp="3rdkisa5iorpx" />
        <PackContents data-id="element-6" data-mp="3rcsuzli5vya7" />
        <InitialTestimonials data-id="element-7" data-mp="3relvej26lm9r" />
        <PainPoints data-id="element-8" data-mp="6hq1ea16ddl" />
        <LaunchOffer data-id="element-9" data-mp="4wylxj0jajy" />
        <MoreTestimonials data-id="element-10" data-mp="56n1goet9nj" />
        <FAQ data-id="element-11" data-mp="2zl3alhpbj03q" />
        <CostComparison data-id="element-12" data-mp="2zld4hgdhhrep" />
        <TransitionPhrase data-id="element-13" data-mp="2zm4wyibsb90r" />
        <EmotionalClose data-id="element-14" data-mp="2zmwguvw0rib7" />
      </main>
      <Footer data-id="element-15" data-mp="33mf2jtvnzxf3" />
      {showSocialProofToast && <FloatingNotification data-id="element-16" data-mp="33nggq77z9011" />}
    </div>;
}